import { render, staticRenderFns } from "./NewTask.vue?vue&type=template&id=292e96a0&scoped=true"
import script from "./NewTask.vue?vue&type=script&lang=js"
export * from "./NewTask.vue?vue&type=script&lang=js"
import style0 from "./NewTask.vue?vue&type=style&index=0&id=292e96a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292e96a0",
  null
  
)

export default component.exports